module.exports = __webpack_public_path__ + "assets/img/6.0c27a886.jpg";